import { find, propEq, values } from 'ramda'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useOpenInWindow } from 'use-open-window'
import { Button } from '@/components/button'
import { isNullOrEmpty } from '@/utils'

const ResolvePaymentButton = ({ paymentData, size }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const viewedTransaction =
    find(
      propEq('coinbase_invoice_last_event', 'viewed'),
      values(paymentData.payment_transactions)
    ) ||
    find(
      propEq('coinbase_invoice_last_event', 'created'),
      values(paymentData.payment_transactions)
    ) ||
    {}

  const windowOptions = {
    centered: true,
    specs: {
      width: 550,
      height: 650
    }
  }
  const [handleWindowOpen] = useOpenInWindow(windowOptions)

  const handleResolve = async event => {
    event.stopPropagation()
    if (!isNullOrEmpty(viewedTransaction)) {
      const transactionUrl = viewedTransaction.coinbase_hosted_url
      handleWindowOpen(event, {
        url: transactionUrl
      })
    } else {
      const { response, body } = await dispatch.settlements.makePayment({
        payment_method: 'crypto',
        crypto_currency: 'bitcoin',
        supplementary_payment: true,
        paymentRequestId: paymentData.id
      })
      if (response.ok) {
        const formattedData = {
          payment_transactions: {
            ...paymentData.payment_transactions,
            temp: {
              coinbase_hosted_url: body.transaction_info.hosted_url,
              coinbase_code: body.transaction_info.code,
              coinbase_invoice_last_event: 'viewed'
            }
          }
        }
        dispatch.payment.patch(
          [paymentData.listing_id, 'payment_requests', paymentData.id],
          formattedData
        )
        handleWindowOpen(event, {
          url: body.transaction_info.hosted_url
        })
      }
    }
  }

  return (
    <Button theme="primary" size={size} onClick={e => handleResolve(e)}>
      {t('r.payment.view.resolve.button', 'Resolve')}
    </Button>
  )
}

export default ResolvePaymentButton
